<template>
  <AuthLayout ref="authLayout" :modal-mode="modalMode" @close="$emit('close')">
    <template #hint>
      <div class="register-hint" @click="onGoRegister">还没有帐号，马上注册</div>
    </template>

    <!-- Tab -->
    <div class="tab-bar">
      <div class="tab-item" :class="{ active: activeTab === 'personal' }" @click="activeTab = 'personal'">
        <span class="tab-text">个人账号</span>
        <div class="tab-underline" v-if="activeTab === 'personal'"></div>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'company' }" @click="activeTab = 'company'">
        <span class="tab-text">企业账号</span>
        <div class="tab-underline" v-if="activeTab === 'company'"></div>
      </div>
    </div>

    <!-- 表单 -->
    <div class="form-body">
      <!-- 手机号 -->
      <div class="input-row">
        <div class="phone-icon"></div>
        <div class="divider-line"></div>
        <input class="input-field" type="text" v-model="account" placeholder="请输入手机号" />
      </div>
      <div class="error-tip">{{ errors.account || '\u00a0' }}</div>

      <!-- 密码 -->
      <div class="input-row">
        <img class="pwd-icon" :src="require('./login-img/FigmaDDSSlicePNG41e10afccef3a0d5ace19978898d13ea.png')" />
        <input class="input-field" type="password" v-model="password" placeholder="请设置8-18位字符登录密码" />
      </div>
      <div class="error-tip">{{ errors.password || '\u00a0' }}</div>

      <!-- 下次自动登录 + 忘记密码 -->
      <div class="remember-row">
        <div class="remember-check" @click="autoLogin = !autoLogin">
          <div class="remember-box" :class="{ checked: autoLogin }">
            <div class="remember-inner" v-if="autoLogin"></div>
          </div>
          <span class="remember-text">下次自动登录</span>
        </div>
        <span class="forget-pwd" @click="onForgetPwd">忘记密码</span>
      </div>

      <!-- 同意协议 -->
      <div class="agree-row" @click="agreed = !agreed">
        <div class="agree-box" :class="{ checked: agreed }">
          <div class="agree-inner" v-if="agreed"></div>
        </div>
        <span class="agree-text">我同意《中国品牌》杂志社的相关规定</span>
      </div>

      <!-- 登录按钮 -->
      <div class="login-btn" @click="handleLogin">立即登录</div>

      <!-- 第三方 -->
      <div class="third-title">使用第三方帐号注册</div>
      <div class="third-icons">
        <img :src="require('./login-img/FigmaDDSSlicePNGc65b4de16bcc52ac78b5d25b8572c8c0.png')" />
        <img :src="require('./login-img/FigmaDDSSlicePNGa1cabcde087145cbbdf74a0d0541ae31.png')" />
        <img :src="require('./login-img/FigmaDDSSlicePNG05002be037565f008cd4dc17f801bce3.png')" />
        <img :src="require('./login-img/FigmaDDSSlicePNGb05e098f4ab44ab58cf213aea3dcc89a.png')" />
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from './AuthLayout.vue'
import { memberLogin, companyLogin } from '../../api'

export default {
  name: 'Login',
  components: {
    AuthLayout
  },
  props: {
    modalMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      account: '',
      password: '',
      agreed: true,
      autoLogin: false,
      activeTab: 'personal',
      errors: { account: '', password: '' },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.errors = { account: '', password: '' }
      if (!this.account) { this.errors.account = '请输入手机号'; return }
      if (!this.password) { this.errors.password = '请输入登录密码'; return }
      if (!this.agreed) { this.$refs.authLayout.showToast('请同意相关规定', 'warning'); return }

      this.loading = true
      const params = {
        loginName: this.account,
        password: this.password,
        loginType: 1
      }
      try {
        const res = this.activeTab === 'personal'
          ? await memberLogin(params)
          : await companyLogin(params)

        const data = res.data || {}
        localStorage.setItem('token', data.token || '')
        localStorage.setItem('userType', this.activeTab)
        localStorage.setItem('userInfo', JSON.stringify(data))

        this.$refs.authLayout.showToast(res.msg || '登录成功', 'success')
        setTimeout(() => {
          if (this.modalMode) {
            this.$emit('login-success')
          } else {
            const redirect = this.$route.query.redirect
            const defaultTarget = this.activeTab === 'personal' ? '/user-center' : '/company-center'
            this.$router.push(redirect || defaultTarget)
          }
        }, 1200)
      } catch (err) {
        this.$refs.authLayout.showToast(err.message || '登录失败', 'error')
      } finally {
        this.loading = false
      }
    },
    onGoRegister() {
      if (this.modalMode) {
        this.$emit('switch-register')
      } else {
        this.$router.push('/register')
      }
    },
    onForgetPwd() {
      if (this.modalMode) {
        this.$emit('close')
      }
      this.$router.push('/forget-password?type=' + (this.activeTab === 'company' ? '2' : '1'))
    }
  }
}
</script>

<style scoped>
/* 顶部提示 */
.register-hint {
  width: 577px;
  text-align: right;
  margin-top: 21px;
  color: rgba(102, 102, 102, 1);
  font-size: 15px;
  font-family: Microsoft YaHei, sans-serif;
  cursor: pointer;
  position: relative;
  z-index: 3;
}
.register-hint:hover { color: rgba(160, 0, 0, 1); }

/* Tab */
.tab-bar {
  display: flex;
  width: 100%;
}
.tab-item {
  flex: 1;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(240, 245, 252, 1);
  border: 1px solid rgba(220, 230, 242, 1);
  border-bottom: none;
  position: relative;
}
.tab-item.active {
  background: rgba(255, 255, 255, 1);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-color: transparent;
  margin-top: -10px;
  height: 90px;
  z-index: 2;
}
.tab-text {
  font-size: 20px;
  color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  white-space: nowrap;
}
.tab-item.active .tab-text { color: rgba(228, 2, 16, 1); }
.tab-underline {
  width: 32px;
  height: 3px;
  background: rgba(228, 2, 16, 1);
  border-radius: 2px;
  margin-top: 6px;
}

/* 表单主体 */
.form-body {
  padding: 0 90px 40px;
  background: rgba(255, 255, 255, 1);
}

/* 输入框行 */
.input-row {
  display: flex;
  align-items: center;
  background: rgba(245, 250, 255, 1);
  border: 1px solid rgba(228, 242, 255, 1);
  border-radius: 24px;
  height: 50px;
  padding: 0 16px 0 18px;
  margin-top: 30px;
}
.phone-icon {
  width: 14px; height: 21px; flex-shrink: 0;
  background: url('./login-img/FigmaDDSSlicePNG1665c2a5d0482cc85b2c49298ea04615.png') center/contain no-repeat;
}
.pwd-icon { width: 14px; height: 18px; flex-shrink: 0; }
.divider-line {
  width: 1px; height: 20px; flex-shrink: 0;
  background: rgba(200, 210, 220, 1);
  margin: 0 10px;
}
.input-field {
  flex: 1; min-width: 0; border: none; outline: none;
  background: transparent; font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  color: rgba(51, 51, 51, 1);
  margin-left: 8px;
}
.input-field::placeholder { color: rgba(178, 178, 178, 1); }

/* 错误提示 */
.error-tip {
  height: 28px; line-height: 28px;
  font-size: 13px; color: rgba(249, 130, 136, 1);
  text-align: center; margin-top: 4px;
}

/* 下次自动登录行 */
.remember-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 4px;
}
.remember-check {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.remember-box {
  width: 14px; height: 14px; flex-shrink: 0;
  border: 1px solid rgba(180, 180, 180, 1);
  position: relative;
}
.remember-box.checked { background: rgba(228, 2, 16, 1); border-color: rgba(228, 2, 16, 1); }
.remember-inner {
  width: 8px; height: 6px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
  position: absolute; top: 2px; left: 1px;
}
.remember-text {
  font-size: 13px;
  color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  margin-left: 6px;
}
.forget-pwd {
  font-size: 13px;
  color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  cursor: pointer;
}
.forget-pwd:hover { color: rgba(228, 2, 16, 1); }

/* 同意协议 */
.agree-row {
  display: flex; align-items: center;
  margin-top: 20px; cursor: pointer;
}
.agree-box {
  width: 14px; height: 14px; flex-shrink: 0;
  border: 1px solid rgba(228, 2, 16, 1);
  position: relative;
}
.agree-box.checked { background: rgba(228, 2, 16, 1); }
.agree-inner {
  width: 8px; height: 6px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
  position: absolute; top: 2px; left: 1px;
}
.agree-text {
  font-size: 14px; color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  margin-left: 8px;
}

/* 登录按钮 */
.login-btn {
  width: 100%; height: 52px;
  background: rgba(160, 0, 0, 1);
  border-radius: 26px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 18px; letter-spacing: 2px;
  font-family: Microsoft YaHei, sans-serif;
  cursor: pointer; margin-top: 16px;
  transition: background 0.2s;
}
.login-btn:hover { background: rgba(130, 0, 0, 1); }

/* 第三方 */
.third-title {
  text-align: center; font-size: 12px;
  color: rgba(102, 102, 102, 1);
  font-family: Microsoft YaHei, sans-serif;
  margin-top: 30px;
}
.third-icons {
  display: flex; justify-content: center;
  gap: 16px; margin-top: 12px;
}
.third-icons img { width: 42px; height: 42px; cursor: pointer; }
</style>
